import { render } from "./Combobox.vue?vue&type=template&id=18c8fb2c&scoped=true"
import script from "./Combobox.vue?vue&type=script&lang=js"
export * from "./Combobox.vue?vue&type=script&lang=js"

import "./Combobox.vue?vue&type=style&index=0&id=18c8fb2c&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\33\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c8fb2c"]])

export default __exports__